import { useLocation, useNavigate } from 'react-router-dom';
import Button, { Size, Color } from 'lib/Button';

interface SubNavigationItems {
  id: number;
  path: string;
  isVisible: boolean;
  name: string;
}

interface SubNavigationProps {
  tabsConfig: SubNavigationItems[];
}

const SubNavigation = ({ tabsConfig }: SubNavigationProps): React.ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const getActiveTab = (config: SubNavigationItems[], locationPathName: string): SubNavigationItems | undefined => {
    return config.find(
      (val: SubNavigationItems) => locationPathName.toLowerCase().includes(val.path.toLowerCase()) && val.isVisible,
    );
  };

  const activeTab = getActiveTab(tabsConfig, location.pathname);

  return (
    <div className="flex items-center">
      {tabsConfig.map((item) => {
        return item.isVisible ? (
          <Button
            size={Size.LARGE}
            color={activeTab?.id === item.id ? Color.NAVIGATION_TAB_ACTIVE : Color.NAVIGATION_TAB}
            onClick={() => {
              navigate(item.path);
            }}
            dataTestId="sub-navigation-tab"
            key={item.id}
            label={item.name}
          />
        ) : null;
      })}
    </div>
  );
};

export default SubNavigation;
